import React from 'react';
import { getAllSellerPickupsList } from 'dashboard/processing/PostingSharedMethods';
import { Link } from 'react-router';
import config from '../../../../config';
import ApiIPA from 'util/ApiIPA.js';
import { hexToBase64, base64ToHex } from 'util/Utils';
import { Button, Col, FormControl, Row } from 'react-bootstrap';
import _ from 'lodash';

export function ScanningScreen(props) {
  const { BarcodeNumber = '' } = props.screensData;
  return (
    <Row className="screen-content">
      <Col xs={6} className="text-center align-center">
        <div className="screen_title">
          <span>
            {`
        Please scan ${props.appData.FeatureFlags.UseGBGIDIn3PL && props.currentFlow == '3PLProcessingFlow' ? 'GBG ID' : 'barcode or GBG ID'
              }`}
          </span>
        </div>

        <div className="top30 set-width" style={{ margin: '0 auto' }}>
          <FormControl
            value={BarcodeNumber}
            componentClass="textarea"
            data-testid="barcode_scanning_screen_input"
            id="barcode_scanning_screen_input"
            ref={(barcodeNumberInput) => {
              props.setBarCodeNumberInput(barcodeNumberInput);
            }}
            placeholder=""
            onKeyPress={(e) => {
              props.setScreensData({ BarcodeNumberTyped: true });
            }}
            onChange={({ target: { value } }) => {
              onTextChange(BarcodeNumber, value, props);
            }}
            type="text"
          />
        </div>

        <div className="top30 ">
          <Button
            data-testid="next-screen-button"
            disabled={props.pending || BarcodeNumber == ''}
            className="btn btn-lg btn-primary set-width "
            onClick={() => {
              onSubmitHandler(props);
            }}
          >
            Continue
          </Button>
        </div>
        {!(props.appData.FeatureFlags.UseGBGIDIn3PL && props.currentFlow == '3PLProcessingFlow') && (
          <div className="top30  set-width" style={{ margin: '0 auto' }}>
            <Link
              data-testid="find-next-available-link"
              className=" text-left pull-left set-width cursor-pointer underlineText"
              onClick={() => {
                props.findNextAvailableCallback();
                props.timerComponent.resetAndStart();
              }}
            >
              Find Next Available
            </Link>
          </div>
        )}
      </Col>
    </Row>
  );
}
function onSubmitHandler(props) {
  if (props.pending) {
    return;
  }

  props.timerComponent.resetAndStart();

  props.setScreensData({ BarcodeNumberTyped: false });

  if ((config.getEnvironmentName() !== 'production' &&
    props.screensData.BarcodeNumber.includes('gbg')) ||
    props.screensData.BarcodeNumber.match(/^\s*G[0-9]+\s*$/)) {
    processGBGID(props.screensData.BarcodeNumber, props);
  } else {
    props.processBarcodeHandler();
  }
}

function getDataForGBGID(GBGID, props) {
  let userId = base64ToHex(props.userReducer.user._id,{convertToHEXUUID: true});

  return ApiIPA.getServiceItem(GBGID, userId).then((response) => {
    // Something went wrong
    if (!response.ok) {
      return response.text().then((bodyData) => {
        const parsedData = JSON.parse(bodyData);
        return Promise.reject({
          message:
            parsedData && parsedData.error ? parsedData.error : `Error occurred when getting data for GBG ID ${GBGID}`,
        });
      });
    }

    return processGetServiceItemsResponse(props, response).catch((err) => {
      props.displayMessage({
        messageType: 'warning',
        messageCode: `GBG ID: ${GBGID}`,
      });
      return Promise.reject({
        message: err && err.message ? err.message : `Error occurred when getting data for GBG ID ${GBGID}`,
      });
    });
  });


}

function processGetServiceItemsResponse(props, response) {

  return response.json().then((responseData) => {
    const { rma = {} } = responseData;
    const { rma_number = false, rma_items = [] } = rma || {};

    // if it is not a rma call
    if (props.currentFlow != '3PLProcessingFlow' || !rma_number || !props.appData.FeatureFlags.RMAProductsSelectionScreenEnabled) {
      responseData.RMAProductsData = {
        RMAProducts: [],
        GBGProductsBrand: '',
        sendRMAProductProcessedEvents: false,
      };
      return responseData;
    }

    const {brand} = (rma_items || [{brand: ""}])[0]
    // process the rma items
    let RMAProducts = rma_items.map((item) => {
      return {
        GBGProductID: item.gbg_product_id,
        RMAProductBrand: item.brand || '',
        RMAProductModel: item.model || '',
        RMAProductID: item.rma_item_id,
        RMAVendorMetaData: item.vendor_metadata,
        RMAProductStatus: item.processing_status ? item.processing_status.toLowerCase() : '',
      };
    });

    // say that this is a rma product flow
    responseData.RMAProductsData = {
      sendRMAProductProcessedEvents: true,
      GBGProductsBrand: brand,
      RMAProducts
    };

    return getGBGProductsForRMAItems(props, RMAProducts).then(RMAProductsToDisplay => {
      responseData.RMAProductsData.RMAProductsToDisplay = RMAProductsToDisplay;
      return responseData;
    });

  });
}


function getGBGProductsForRMAItems(props, RMAProducts) {
  const GBGProductIDs = RMAProducts.filter((item) => item.GBGProductID).map((item) =>
    hexToBase64(item.GBGProductID)
  );
  return props.makeRequest({ recordIDs: GBGProductIDs }, { endpoint: '/gbg_products' }).then((res) => {
    const GBGProducts = res.data.data;
    RMAProducts.forEach((item) => {
      const foundGBGProduct = GBGProducts.find((GBGProduct) => {
        return item.GBGProductID && GBGProduct._id == hexToBase64(item.GBGProductID);
      });
      item.GBGProductRecord = foundGBGProduct ? foundGBGProduct : {};
    });
    const RMAProductsWithGBGProductID = RMAProducts.filter((item) => item.GBGProductID);
    const RMAProductsWithoutGBGProductID = RMAProducts.filter((item) => !item.GBGProductID);
    RMAProductsWithoutGBGProductID.forEach((item) => {
      item.alreadyPosted =  item.RMAProductStatus != 'rma_created' ;
    });
    let itemsGroupedByGBGProductID = _.groupBy(RMAProductsWithGBGProductID, (item) => {
      return item.GBGProductRecord._id;
    });

    let RMAProductsToDisplay = [];


    for (const [, items] of Object.entries(itemsGroupedByGBGProductID)) {
      const alreadyPosted = items.every((item) => {
        return item.RMAProductStatus != 'rma_created'
      });
      RMAProductsToDisplay.push({
        ...items[0],
        alreadyPosted,
        RMAItemsForGBGProduct: items,
      });
    }


    return RMAProductsToDisplay.concat(RMAProductsWithoutGBGProductID);
  });
}

function processGBGID(BarcodeNumber, props) {
  BarcodeNumber = BarcodeNumber.trim();
  getDataForGBGID(BarcodeNumber, props).then((responseData) => {
      if (!responseData.RMAProductsData.sendRMAProductProcessedEvents) {
        Object.assign(responseData.RMAProductsData, {
          RMAProducts: [],
          GBGProductsBrand: '',
          sendRMAProductProcessedEvents: false,
        });
      }

      const foundSellerAndPickup = props.allSellerPickupsListReducer.data.find(
        (item) => item._id === hexToBase64(responseData.service_id)
      );

      if (foundSellerAndPickup) {
        props.timerComponent.resetAndStart();
        props.processGBGIDCallback(responseData, foundSellerAndPickup);
      } else {
        props.displayMessage({
          messageType: 'warning',
          messageCode: 'Seller and service records not found',
        });
        getAllSellerPickupsList.call({ props: { ...props } });
      }
    }).catch((err) => {
      console.log('err', err);
      props.displayMessage({
        messageType: 'warning',
        messageCode: err.message,
      });
      props.updateParentComponentState({ pending: false });
    });
}

function onTextChange(BarcodeNumber, value, props) {
  let dataToUpdate = { BarcodeNumber: value };
  let { BarcodeNumberTyped = false } = props.screensData;

  if (BarcodeNumber.length > value.length) {
    /* when data is removed onKeyPress is not triggered */
    dataToUpdate.BarcodeNumberTyped = BarcodeNumberTyped = true;
  }

  props.setScreensData(dataToUpdate, () => {
    if (!BarcodeNumberTyped && dataToUpdate.BarcodeNumber) {
      if (
        (config.getEnvironmentName() !== 'production' && dataToUpdate.BarcodeNumber.includes('gbg')) ||
        dataToUpdate.BarcodeNumber.match(/^G[0-9]+$/)
      ) {
        return processGBGID(dataToUpdate.BarcodeNumber, props);
      }
      return props.barcodeScanningTextCallback();
    }
    if (value == '') {
      props.setScreensData({ BarcodeNumberTyped: false });
    }
  });
}
